import { render, staticRenderFns } from "./MarketProductPromo.vue?vue&type=template&id=2152f37e&scoped=true&"
import script from "./MarketProductPromo.vue?vue&type=script&lang=js&"
export * from "./MarketProductPromo.vue?vue&type=script&lang=js&"
import style0 from "./MarketProductPromo.vue?vue&type=style&index=0&id=2152f37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2152f37e",
  null
  
)

export default component.exports